import '@assets/css/skeleton.css';

export const ProductDetailSkeleton = () => {
  return (
    <>
      {/* Header card - 2 cột ảnh + thông tin */}
      <div className="card border-0 shadow-sm mt-4 overflow-hidden">
        <div className="row g-0">
          {/* Left column - image */}
          <div className="col-lg-5">
            <div className="h-100 bg-light p-4">
              <div className="shimmer" style={{ height: 420, width: '100%', borderRadius: 12 }} />
              <div className="row g-2 mt-2">
                {[1, 2, 3, 4].map((i) => (
                  <div className="col-3" key={i}>
                    <div className="shimmer" style={{ height: 72, width: '100%', borderRadius: 8 }} />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right column - info */}
          <div className="col-lg-7">
            <div className="card-body p-4">
              <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
                <div>
                  <div className="d-flex gap-2 mb-2">
                    <div className="shimmer" style={{ height: 24, width: 80, borderRadius: 20 }} />
                    <div className="shimmer" style={{ height: 24, width: 80, borderRadius: 20 }} />
                    <div className="shimmer" style={{ height: 24, width: 80, borderRadius: 20 }} />
                  </div>
                  <div className="shimmer" style={{ height: 32, width: '70%', marginBottom: 8 }} />
                  <div className="shimmer" style={{ height: 20, width: '40%', marginBottom: 8 }} />
                  <div className="shimmer" style={{ height: 18, width: '30%' }} />
                </div>
                <div className="text-lg-end">
                  <div className="shimmer" style={{ height: 16, width: 60, marginBottom: 4 }} />
                  <div className="shimmer" style={{ height: 20, width: 120 }} />
                </div>
              </div>

              {/* Metrics row */}
              <div className="row g-3 mt-1">
                {[1, 2, 3, 4].map((i) => (
                  <div className="col-md-3" key={i}>
                    <div className="border rounded-3 p-3">
                      <div className="shimmer" style={{ height: 14, width: '60%', marginBottom: 4 }} />
                      <div className="shimmer" style={{ height: 24, width: '50%' }} />
                    </div>
                  </div>
                ))}
              </div>

              {/* Action buttons */}
              <div className="d-flex align-items-center gap-3 mt-4">
                <div className="shimmer" style={{ height: 40, width: 140, borderRadius: 4 }} />
                <div className="shimmer" style={{ height: 20, width: 120 }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Form configuration */}
      <div className="row mt-4">
        <div className="col-lg-8">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="shimmer" style={{ height: 28, width: '30%', marginBottom: 16 }} />
              <div className="row g-3">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
                  <div className="col-md-6" key={i}>
                    <div className="shimmer" style={{ height: 16, width: '40%', marginBottom: 4 }} />
                    <div className="shimmer" style={{ height: 38, width: '100%' }} />
                  </div>
                ))}
                <div className="col-12">
                  <div className="shimmer" style={{ height: 16, width: '30%', marginBottom: 4 }} />
                  <div className="shimmer" style={{ height: 80, width: '100%' }} />
                </div>
                <div className="col-12">
                  <div className="shimmer" style={{ height: 16, width: '30%', marginBottom: 4 }} />
                  <div className="shimmer" style={{ height: 80, width: '100%' }} />
                </div>
                <div className="col-md-6">
                  <div className="shimmer" style={{ height: 16, width: '40%', marginBottom: 4 }} />
                  <div className="shimmer" style={{ height: 38, width: '100%' }} />
                </div>
                <div className="col-md-6">
                  <div className="shimmer" style={{ height: 16, width: '40%', marginBottom: 4 }} />
                  <div className="shimmer" style={{ height: 38, width: '100%' }} />
                </div>
                <div className="col-md-6">
                  <div className="shimmer" style={{ height: 16, width: '40%', marginBottom: 4 }} />
                  <div className="shimmer" style={{ height: 38, width: '100%' }} />
                </div>
                <div className="col-md-6">
                  <div className="shimmer" style={{ height: 16, width: '40%', marginBottom: 4 }} />
                  <div className="shimmer" style={{ height: 38, width: '100%' }} />
                </div>
                <div className="col-12">
                  <div className="shimmer" style={{ height: 16, width: '30%', marginBottom: 4 }} />
                  <div className="shimmer" style={{ height: 80, width: '100%' }} />
                </div>
              </div>
              <div className="d-flex align-items-center gap-3 mt-4">
                <div className="shimmer" style={{ height: 40, width: 140, borderRadius: 4 }} />
                <div className="shimmer" style={{ height: 40, width: 140, borderRadius: 4 }} />
              </div>
            </div>
          </div>
        </div>

        {/* Right column - metadata + gallery */}
        <div className="col-lg-4 mt-4 mt-lg-0">
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="shimmer" style={{ height: 24, width: '50%', marginBottom: 16 }} />
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="d-flex justify-content-between border rounded-3 p-3 mb-2">
                  <div className="shimmer" style={{ height: 16, width: '40%' }} />
                  <div className="shimmer" style={{ height: 16, width: '40%' }} />
                </div>
              ))}
            </div>
          </div>

          <div className="card border-0 shadow-sm mt-4">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="shimmer" style={{ height: 24, width: '40%' }} />
                <div className="shimmer" style={{ height: 16, width: '30%' }} />
              </div>
              <div className="shimmer" style={{ height: 38, width: '100%' }} />
              <div className="shimmer" style={{ height: 16, width: '60%', marginTop: 8 }} />
              <div className="mt-3">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="d-flex align-items-center gap-3 border rounded-3 p-2 mb-2">
                    <div className="shimmer" style={{ width: 56, height: 56, borderRadius: 8 }} />
                    <div className="flex-grow-1">
                      <div className="shimmer" style={{ height: 16, width: '50%' }} />
                    </div>
                    <div className="shimmer" style={{ height: 32, width: 80, borderRadius: 4 }} />
                    <div className="shimmer" style={{ height: 32, width: 80, borderRadius: 4 }} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Related products */}
      <div className="card border-0 shadow-sm mt-4">
        <div className="card-body">
          <div className="shimmer" style={{ height: 28, width: '30%', marginBottom: 16 }} />
          <div className="row">
            {[1, 2, 3, 4].map((i) => (
              <div className="col-md-6 col-xl-3 mt-3" key={i}>
                <div className="border rounded-3 h-100 overflow-hidden">
                  <div className="shimmer" style={{ height: 160, width: '100%' }} />
                  <div className="p-3">
                    <div className="d-flex justify-content-between gap-2">
                      <div className="shimmer" style={{ height: 20, width: '60%' }} />
                      <div className="shimmer" style={{ height: 20, width: '30%', borderRadius: 20 }} />
                    </div>
                    <div className="shimmer" style={{ height: 16, width: '40%', marginTop: 8, marginBottom: 12 }} />
                    <div className="shimmer" style={{ height: 24, width: '50%', marginBottom: 12 }} />
                    <div className="shimmer" style={{ height: 36, width: '100%', borderRadius: 4 }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};